import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll position and overflow on every route change.
 */
export function useScrollReset() {
  const location = useLocation();

  useEffect(() => {
    document.getElementsByTagName('html')[0].style.overflow = 'unset';
    window.scrollTo(0, 0);
  }, [location]);
}
